export const STATUS_OK = "1";
export const NO_EXIST = "14";
export const STATUS_ERROR = "0";
export const DEL_FLAG_IS = 1;
export const DEL_FLAG_NOT = 0;
export const PAGE_SIZE = 12;
export const STATUS_TIME_OUT = '18'

export const EXERCISES_TYPE = {
  one: 1, // 单选
  multi: 2, // 多选
  judge: 3, // 判断
  filling: 4, // 填空
  ask: 5, // 简答
  comprehensive: 6, // 综合
  account:8, // 分录
  table: 9 // 表格
}

export const CW_PAGE_CONTENT_TYPE = {
  img: 1,//图片
  video: 2,//视频
  flash: 3,//flash
  txt: 5,//文本
  pdf: 6,//文档PDF
  paper: 7//试题
}

export const STAMP_OFFSET = 10;
export const LINE_OFFSET = 20;
export const STAMP_TYPE = 11;
export const LINE_TYPE = 10;

//测试状态
export const REPORT_TYPE = [
  '未发布',
  '未开始',
  '考试中',
  '考试截止',
  '已发送成绩'
];

//学生测试提交状态
export const STU_SUBMIT_TYPE = [
  '已提交',
  '未提交',
  '迟交'
];
//练习库发送状态
export const PRACTICE_PUSH_STATUS = [
  '撤回',
  '推送',
  '变更',
];
// 考试类型
export const EXAM_TYPE = [
  '考试',
  '测验',
  '作业'
];
// 系统课程类型
export const SYS_COURSE_TYPE = [
  {
    "id":1,
    "name":"基础课"
  },
  {
    "id":2,
    "name":"专业课"
  },
  {
    "id":3,
    "name":"考证"
  }
];
export const MSG_TYPE = {
  CLASS_IS_BEGIN:5,
  CLASS_IS_OVER:6,
  SEND_HAND:20,
  HAND_ON:21,
  HAND_OFF:22,
  HAND_REPLAY:23
}

export const SCREEN_WIDTH = 1360;            // 区分大屏小屏的临界值
export const TABLE_MAX_WIDTH = 1160;         // 浏览器宽> 1360px, 添加试题的表格 标准宽度,印章的宽为数据库值,否则缩放印章大小
export const TABLE_SMALL_WIDTH = 860;        // 浏览器宽< 1360px, 添加浏览表格宽度都为 914

export const RESOURCE_TYPE_IMAGE = 1;
export const RESOURCE_TYPE_VIDEO = 2;
export const RESOURCE_TYPE_DOCUMENT = 3;
export const RESOURCE_TYPE_GAME = 5;

export const RESOURCE_EXIST = 16;
export const EXERCISES_BANK_EXIST = 16;
export const RESOURCE_NO_EXIST = 14;

//user 用户
export const SET_USER_INFO = 'SET_USER_INFO'      //设置用户信息
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS' //设置登录状态

export const SET_MY_COURSES = 'SET_MY_COURSES'
export const SET_OPEN_COURSES = 'SET_OPEN_COURSES'
export const CLEAR_MY_COURSE = 'CLEAR_MY_COURSE'
export const CLEAR_OPEN_COURSE = 'CLEAR_OPEN_COURSE'
export const SET_MAJORTYPE = 'SET_MAJORTYPE'
export const SET_MAJOR = 'SET_MAJOR'
export const SET_CCOURSE = 'SET_CCOURSE'
export const SET_COURSE_CONTENT = 'SET_COURSE_CONTENT'
export const TO_COURSECONTENT_ID = 'TO_COURSECONTENT_ID'
export const SET_DESIGN_MODULES = 'SET_DESIGN_MODULES'
export const SET_COURSE_HOURS = 'SET_COURSE_HOURS'
export const SET_STUDENTS = 'SET_STUDENTS'
export const SET_CSTUDENT = 'SET_CSTUDENT'
export const SET_COURSE_HOUR = 'SET_COURSE_HOUR' //课程的所有课时
export const SET_TEACHING = 'SET_TEACHING' //某一个课时教学过程 教学设计
export const SET_TEACH_INDEX = 'SET_TEACH_INDEX'

//班级管理
export const SET_MY_ClASSROOM = 'SET_MY_CLASSROOM'
export const SET_CClASSROOM = 'SET_CClASSROOM'
export const SET_CLASSMAJORTYPE = 'SET_CLASSMAJORTYPE'
export const SET_CLASSMAJOR = 'SET_CLASSMAJOR'
export const SET_GRADEYEAR = 'SET_GRADEYEAR'
export const SET_CLASSROOMS = 'SET_CLASSROOMS'

export const ADMIN_PATH = 'interface/admin'
export const TEACH_PATH = 'interface/teach'
export const STUDENT_PATH = '/inter/android'
export const RESOURCE_PATH = 'interface/resources'

export const SET_SCREEN_WIDTH = 'SET_SCREEN_WIDTH'
export const SET_SCREEN_HEIGHT = 'SET_SCREEN_HEIGHT'

export const SET_GIVE_STEPS = "SET_GIVE_STEPS"
export const SET_GIVE_SENDS = "SET_GIVE_SENDS"
export const SET_GIVE_RESOURCES = "SET_GIVE_RESOURCES"
export const SET_KNOWLEDGELIST = "SET_KNOWLEDGELIST"
export const SET_BASIC_TABLE_TEMPLATE_LIST = "SET_BASIC_TABLE_TEMPLATE_LIST"
export const SET_CTABLE_TEMPLATE = "SET_CTABLE_TEMPLATE"
export const SET_ELEMENT_LIST = "SET_ELEMENT_LIST"
export const SET_IMPRESS_REMAIN = 'SET_IMPRESS_REMAIN'
export const SET_TOPIC_LIST = 'SET_TOPIC_LIST'
export const SET_TOPIC_SIGN = 'SET_TOPIC_SIGN'
export const SET_LINE_LIST = 'SET_LINE_LIST'
export const SET_SUBJECTLIST = 'SET_SUBJECTLIST'
export const SET_TOP = 'SET_TOP';
export const SET_CHAPTER_LIST = 'SET_CHAPTER_LIST';


//测验-试题库-试题浏览
export const SET_BANK_COURSELIST = "SET_BANK_COURSELIST";
export const SET_MY_BANK_LIST = "SET_MY_BANK_LIST";

export const FILE_SIZE_4M = 1024 * 1024 * 4
export const IFRAM_FLASH_PATH = './static/html/swf.html'
export const IFRAM_VIDEO_PATH = './static/html/video.html'

// 课件start
export const SET_COURSEWAREID = "SET_COURSEWAREID";
export const SET_COURSEWARE = "SET_COURSEWARE";

export const QUERY_CLASS_INFO_SUCCESS = "QUERY_CLASS_INFO_SUCCESS";

export const SCROLL_LOADING = {
  DELAY_TIME: 500,
  BANK_LIST_PAGE_SIZE: 8,                 // 试题库分页显示每页数量
  PAPER_LIST_PAGE_SIZE: 8,                 // 试卷库分页显示每页数量
  EXERCISE_PAGE_SIZE: 8,                   // 试题页面显示每页数量
  REPORT_LIST_PAGE_SIZE: 8,               // 测验报告分页显示每页数量
  CHAPTER_LIST_PAGE_SIZE: 8,               // 章分页显示每页数量
  SECTION_LIST_PAGE_SIZE: 8               // 节分页显示每页数量
}
export const SKILL_MATCH_SERVER_HOST = ""; // ！！！相对路径为空，不同环境请到nginx配置代理skill路径到技能训练后台，不要改！！！
export const SERVER_IP = '/';
export const FILE_SERVER_URL = '';
export const ANON_URL = ['/login', '/mobileLogin', '/noaccess','/mobileExamination'];



// WEBPACK FOOTER //
// ./src/vuex/types.js